import { render, staticRenderFns } from "./Step22.vue?vue&type=template&id=5431e2f0&scoped=true"
import script from "./Step22.vue?vue&type=script&lang=js"
export * from "./Step22.vue?vue&type=script&lang=js"
import style0 from "./Step22.vue?vue&type=style&index=0&id=5431e2f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5431e2f0",
  null
  
)

export default component.exports